<div class="approve-page">
  <div class="approve-card">

    <div *ngIf="loading" class="state-box loading-state">
      <div class="spinner"></div>
      <h2>Processing Approval</h2>
      <p>Please wait while we verify and process your request.</p>
    </div>

    <div *ngIf="isSuccess" class="state-box success-state">
      <div class="icon success-icon">✓</div>
      <h2>Order Approved</h2>
      <p class="message">{{ message }}</p>
      <p class="redirect-text">
        You will be redirected to the home page in
        <strong>{{ countdown }}</strong> seconds.
      </p>
      <button class="action-btn success-btn" (click)="goHome()">Go Home Now</button>
    </div>

    <div *ngIf="isError" class="state-box error-state">
      <div class="icon error-icon">✕</div>
      <h2>Approval Failed</h2>
      <p class="message">{{ message }}</p>
      <button class="action-btn error-btn" (click)="goHome()">Back to Home</button>
    </div>

  </div>
</div>
